import React, { useContext, useEffect, useState } from 'react';
import { Row, Modal, Typography } from 'antd';
import { FormInstance } from 'antd/lib/form';
import FormInput from 'components/FormInput';
import GetLabel from 'DisplayFramework/components/GetLabel';
import ButtonLink from 'components/theme_components/ButtonLink';
import { AuthContext } from 'components/Auth/Auth';
import InputCurrency from 'components/InputCurrency';
import { TpAuthorizationResponse } from 'services/thirdParty';
import ConfirmModal from 'components/theme_components/ThirdParty/ConfirmModal';
export type ActivityModalProps = {
  form: FormInstance;
  onDone: any;
  onCancel: any;
  dataInput: TpAuthorizationResponse;
  loading: boolean;
};

const TabUpdateAuthAmount = ({
  form,
  onDone,
  onCancel,
  dataInput,
  loading,
}: ActivityModalProps) => {
  const { isInspect } = useContext(AuthContext);
  const [modal, contextHolder] = Modal.useModal();
  const [modalVisible, setModalVisible] = useState(false);
  const [confirmModalVisible, setConfirmModalVisible] = useState(false);
  const [MPAconfirmModalVisible, setMPAConfirmModalVisible] = useState(false);

  const [updateMPA, setUpdateMPA] = useState(false);
  const [authamount, setauthamount] = useState(dataInput.authamount);

  const { confirm } = Modal;
  const { Title } = Typography;

  useEffect(() => {
    if (dataInput && dataInput.authDetail) {
      form.setFieldsValue({
        authdetailid: dataInput.authDetail[0].authdetailid,
        event: 'TabUpdateAuthAmount',
        authdetailamount: authamount,
        authid: dataInput.authid,
        authcalculatedamount: dataInput.authcalculatedamount,
      });
    }
  }, [dataInput, form]);

  const importAll = (r: any) => {
    let images: any = {};
    r.keys().map((item: any, index: any) => {
      images[item.replace('./', '')] = r(item);
    });
    return images;
  };

  const images: any = importAll(
    require.context('/src/assets/', false, /\.(png|jpg|jpe?g|svg)$/)
  );
  let icon: any;
  if (status === 'success') {
    icon = images['success.jpg'];
  } else if (status === 'error') {
    icon = images['warning.png'];
  }

  const validateFields = () => {
    form.validateFields().then(() => {
      if (
        !(
          form.getFieldValue('authdetailamount') <=
          form.getFieldValue('authcalculatedamount')
        )
      ) {
        setModalVisible(true);
      } else {
        onDone();
      }
    });
  };

  return (
    <div>
      {updateMPA ? (
        <FormInput
          col
          xs={24}
          lg={24}
          name="authcalculatedamount"
          labelCol={{ span: 24 }}
          className="no-border-radius ut-activaty-custom-antd-from"
          rules={[
            {
              required: true,
              validator: (_, value) => {
                if (form.getFieldValue('authdetailamount') <= value) {
                  return Promise.resolve();
                } else {
                  return Promise.reject(
                    new Error(
                      'le montant de la MPEA doit être superieur ou égale au montant du normal limit '
                    )
                  );
                }
              },
            },
          ]}
        >
          <InputCurrency
            className="ut-input-modal ut-activaty-custom-input"
            min={authamount}
            onChange={(e: any) => {
              form.setFieldsValue({
                authdetailamount: authamount,
              });
            }}
          />
        </FormInput>
      ) : (
        <FormInput
          col
          xs={24}
          lg={24}
          name="authdetailamount"
          labelCol={{ span: 24 }}
          className="no-border-radius ut-activaty-custom-antd-from"
          rules={[
            {
              required: false,
              validator: (_, value) => {
                console.log(value);

                const overactivityRate =
                  dataInput.authToleranceList[0]?.toleranceRate || 0;
                const overactivityAmount =
                  dataInput.authToleranceList[0]?.toleranceAmount || 0;

                let calculatedAmount = 0;
                if ((overactivityRate !== 0 || overactivityAmount !== 0) && dataInput.authToleranceStatus === 'ACTIVE') {
                  calculatedAmount =
                    (value * overactivityRate) / 100 +
                    overactivityAmount;
                }

                const newAmount = calculatedAmount
                  ? value + calculatedAmount
                  : value;
                
                if (newAmount <= dataInput.authcalculatedamount) {
                  return Promise.resolve();
                } else {
                  return Promise.reject(
                    new Error(
                      'le montant du normal limit doit être inférieur ou égale à la MPEA'
                    )
                  );
                }
              },
            },
          ]}
        >
          <InputCurrency
            className="ut-input-modal ut-activaty-custom-input"
            onChange={(e: any) => {
              setauthamount(e);
            }}
          />
        </FormInput>
      )}

      <Row justify={'end'} style={{ marginTop: 13 }}>
        <ButtonLink
          comcode="Annuler"
          className="ut-btn-bordred"
          onClick={() => !isInspect && onCancel()}
        />

        <ButtonLink
          type="primary"
          comcode="Valider"
          htmlType="submit"
          className="ut-reset-btn"
          loading={loading}
          onClick={() => !isInspect && validateFields()}
          iconPosition="end"
        />
      </Row>
      <ConfirmModal
        visible={modalVisible}
        status="error"
        message={
          'Souhaitez vous modifier la Normal Limit de  ' +
          dataInput.authcalculatedamount +
          ' € à ' +
          form.getFieldValue('authdetailamount') +
          ' € ? '
        }
        onConfirm={() => {
          setModalVisible(false);
          setConfirmModalVisible(true);
        }}
        onCancel={() => !isInspect && setModalVisible(false)}
        className="modalConfirmOrCancel"
      />
      <ConfirmModal
        visible={confirmModalVisible}
        status="error"
        message={
          'La Normal Limit est supérieur à la MPEA, voulez-vous également modifier la MPEA ? '
        }
        onConfirm={() => {
          setConfirmModalVisible(false);
          setUpdateMPA(true);
        }}
        onCancel={() => !isInspect && setConfirmModalVisible(false)}
        className="modalConfirmOrCancel"
      />
      <ConfirmModal
        visible={MPAconfirmModalVisible}
        status="error"
        message={
          'Souhaitez vous modifier la limite MPEA de  ' +
          dataInput.authcalculatedamount +
          '  € à  ' +
          form.getFieldValue('authcalculatedamount') +
          '  € ? '
        }
        onConfirm={() => {
          setMPAConfirmModalVisible(false);
          onDone;
        }}
        onCancel={() => !isInspect && setConfirmModalVisible(false)}
        className="modalConfirmOrCancel"
      />
    </div>
  );
};

export default TabUpdateAuthAmount;
